import { Routes } from '../../app/routes';

export interface PaletteCommand {
  id: string;
  label: string;
  group: 'navigation' | 'create' | 'action';
  keywords?: string[];
  action: (ctx: CommandContext) => void;
}

export interface CommandContext {
  navigate: (path: string) => void;
  dispatch: (action: { type: string; payload?: unknown }) => void;
}

export const navigationCommands: PaletteCommand[] = [
  {
    id: 'nav-dashboard',
    label: 'Go to Dashboard',
    group: 'navigation',
    keywords: ['home'],
    action: (ctx) => ctx.navigate(Routes.DASHBOARD.link),
  },
  {
    id: 'nav-events',
    label: 'Go to Events',
    group: 'navigation',
    keywords: ['calendar'],
    action: (ctx) => ctx.navigate(Routes.EVENTS.link),
  },
  {
    id: 'nav-orders',
    label: 'Go to Orders',
    group: 'navigation',
    keywords: ['purchases', 'sales'],
    action: (ctx) => ctx.navigate(Routes.ORDERS.link),
  },
  {
    id: 'nav-products',
    label: 'Go to Products',
    group: 'navigation',
    action: (ctx) => ctx.navigate(Routes.PRODUCTS.link),
  },
  {
    id: 'nav-users',
    label: 'Go to Users',
    group: 'navigation',
    keywords: ['customers'],
    action: (ctx) => ctx.navigate(Routes.USERS.link),
  },
  {
    id: 'nav-coupons',
    label: 'Go to Coupons',
    group: 'navigation',
    keywords: ['discounts', 'promo'],
    action: (ctx) => ctx.navigate(Routes.COUPONS.link),
  },
  {
    id: 'nav-enquiries',
    label: 'Go to Enquiries',
    group: 'navigation',
    keywords: ['contact', 'messages'],
    action: (ctx) => ctx.navigate(Routes.ENQUIRIES.link),
  },
  {
    id: 'nav-settings',
    label: 'Go to Settings',
    group: 'navigation',
    keywords: ['config', 'preferences'],
    action: (ctx) => ctx.navigate('/settings'),
  },
  {
    id: 'nav-staging',
    label: 'Go to Staging',
    group: 'navigation',
    keywords: ['uploads', 'pending'],
    action: (ctx) => ctx.navigate(Routes.STAGING.link),
  },
  {
    id: 'nav-tasks',
    label: 'Go to Tasks',
    group: 'navigation',
    keywords: ['jobs', 'processing'],
    action: (ctx) => ctx.navigate(Routes.TASKS.link),
  },
  {
    id: 'nav-selectors',
    label: 'Go to Product Selectors',
    group: 'navigation',
    action: (ctx) => ctx.navigate(Routes.PRODUCT_SELECTORS.link),
  },
];

export const createCommands: PaletteCommand[] = [
  {
    id: 'create-event',
    label: 'Create Event',
    group: 'create',
    keywords: ['new event'],
    action: (ctx) =>
      ctx.dispatch({
        type: 'modal/open',
        payload: { title: 'Create Event', contentKey: 'create-event' },
      }),
  },
  {
    id: 'create-product',
    label: 'Create Product',
    group: 'create',
    keywords: ['new product'],
    action: (ctx) =>
      ctx.dispatch({
        type: 'modal/open',
        payload: { title: 'Create Product', contentKey: 'create-product' },
      }),
  },
  {
    id: 'create-coupon',
    label: 'Create Coupon',
    group: 'create',
    keywords: ['new coupon', 'new discount'],
    action: (ctx) =>
      ctx.dispatch({
        type: 'modal/open',
        payload: { title: 'Create Coupon', contentKey: 'create-coupon' },
      }),
  },
  {
    id: 'create-user',
    label: 'Create User',
    group: 'create',
    keywords: ['new user', 'add user'],
    action: (ctx) =>
      ctx.dispatch({
        type: 'modal/open',
        payload: { title: 'Create User', contentKey: 'create-user' },
      }),
  },
];

export const actionCommands: PaletteCommand[] = [
  {
    id: 'switch-account',
    label: 'Switch Account',
    group: 'action',
    keywords: ['change account'],
    action: (ctx) => ctx.navigate(Routes.SWITCHACCOUNT.link),
  },
  {
    id: 'logout',
    label: 'Logout',
    group: 'action',
    keywords: ['sign out'],
    action: (ctx) => ctx.dispatch({ type: 'auth/clearToken' }),
  },
];

export const allCommands = [
  ...navigationCommands,
  ...createCommands,
  ...actionCommands,
];
